<template>
  <div class="modal">
    <div class="modal-window" v-if="tests.length === 0">
      <span class="close" @click="$emit('close')">
        <font-awesome-icon icon="times"/>
      </span>
      <div class="text">
        В данной группе не добавлено ни одного теста.
      </div>
    </div>
    <div class="modal-window" v-else>
      <span class="close" @click="$emit('close')">
        <font-awesome-icon icon="times"/>
      </span>
      <div class="top-line text">
        Выберите тест, по которому хотите получить отчет:
      </div>
      <div v-for="test in tests" :key="test.id">
        <a @click="$emit('close')" :href="csvLoad(test.id)" class="btn">{{testNum +1}}. {{test.name}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import TestsService from '@/services/TestsService'

  export default {
    name: 'CSVModal',
    props: {
      groupId: Number
    },
    data () {
      return {
        tests: [],
        url: '',
        testNum: 0
      }
    },
    methods: {
      getTests () {
        const groupId = this.groupId
        TestsService.getTestsByGroupId(groupId).then(
          (response) => {
            this.tests = response
          }
        )
      },
      csvLoad (testId) {
        const slug = this.$store.getters.slug
        const groupId = this.groupId
        const api = process.env.API_ADMIN
        return api + `/organizations/${slug}/groups/${groupId}/tests/${testId}/download-results`
      }
    },
    mounted () {
      this.getTests()
      this.csvLoad()
    }
  }
</script>

<style scoped lang="scss">
  span.close {
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;
  }

  .text {
    font-size: 22px;
    font-weight: 300;
  }

  .btn {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    margin: 0 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/CSVModal.vue